/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import React, { useState, useRef, useEffect, useContext, useCallback } from 'react';
import styled from 'styled-components';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import { Absolute, Box, Flex, Relative } from 'pcln-design-system';
import RealTimeHeader from './components/Realtime/RealTimeHeader/RealTimeHeader';
import { Close as CloseIcon, Microphone, MicOff } from 'pcln-icons';
import RenderMarkers from './components/Realtime/RenderMarkers/RenderMarkers';
import BotWithAnimatedBorder from './components/Realtime/BotWithAnimatedBorder/BotWithAnimatedBorder';
import { floatTo16BitPCM, convertPCM16ToBase64, base64ToArrayBuffer, convertPCM16ToFloat32 } from './utils/audio';
const Container = /*#__PURE__*/styled(Box).withConfig({
  displayName: "RealtimeChatDialogContent__Container",
  componentId: "sc-1duxqmh-0"
})(["display:flex;flex-direction:column;justify-content:center;background:linear-gradient( 144.03deg,#7701bb 26.24%,#7601bb 30.85%,#7503bc 35.32%,#7205bd 39.67%,#6e09bf 43.9%,#690dc1 48.03%,#6312c4 52.1%,#5c18c7 56.1%,#541fca 60.07%,#4c27ce 64.01%,#422fd2 67.94%,#3738d7 71.89%,#2c42dc 75.87%,#204de1 79.89%,#1358e7 83.98%,#0564ed 88.15% ),radial-gradient( 37.63% 77.06% at -3.33% 9.11%,rgba(245,235,250,0.6) 0%,rgba(238,222,246,0.51875) 16.15%,rgba(232,210,243,0.441421) 33.33%,rgba(209,168,232,0.174338) 66.15%,rgba(201,153,228,0.0827664) 82.29%,rgba(194,140,224,0) 100% ),radial-gradient( 22.92% 32.88% at 93.06% 103.5%,rgba(232,242,255,0) 0%,rgba(232,242,255,0) 0.01%,rgba(153,195,249,0) 100% );"]);
const HeaderWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "RealtimeChatDialogContent__HeaderWrapper",
  componentId: "sc-1duxqmh-1"
})(["height:57px;justify-content:center;align-items:center;"]);
const BodyWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "RealtimeChatDialogContent__BodyWrapper",
  componentId: "sc-1duxqmh-2"
})(["flex-grow:1;justify-content:center;align-items:center;flex-direction:column;"]);
const InnerBodyWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "RealtimeChatDialogContent__InnerBodyWrapper",
  componentId: "sc-1duxqmh-3"
})(["overflow-y:auto;height:70%;position:relative;top:-100px;"]);
const FooterWrapper = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "RealtimeChatDialogContent__FooterWrapper",
  componentId: "sc-1duxqmh-4"
})(["bottom:16px;height:48px;width:100%;background:transparent;"]);
const ControlWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "RealtimeChatDialogContent__ControlWrapper",
  componentId: "sc-1duxqmh-5"
})(["align-items:center;justify-content:space-between;height:48px;"]);
const Mic = /*#__PURE__*/styled(Box).withConfig({
  displayName: "RealtimeChatDialogContent__Mic",
  componentId: "sc-1duxqmh-6"
})(["cursor:pointer;border-radius:50%;width:45px;height:45px;background:transparent;display:flex;align-items:center;justify-content:center;"]);
const Close = /*#__PURE__*/styled(Mic).withConfig({
  displayName: "RealtimeChatDialogContent__Close",
  componentId: "sc-1duxqmh-7"
})(["background:transparent;"]);
const ChildWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "RealtimeChatDialogContent__ChildWrapper",
  componentId: "sc-1duxqmh-8"
})(["position:relative;top:-80px;"]);
/**
 * AudioRecorder component handles real-time audio recording and playback functionality
 * @internal
 */
const AudioRecorder = ({
  realtimeContext
}) => {
  var _a;
  const [isRecording, setIsRecording] = useState(false);
  const [itemCreate, setItemCreate] = useState();
  const [ws, setWs] = useState(null);
  const [rtMessages, setRtMessages] = useState([]);
  const [userMessages, setUserMessages] = useState([]);
  const [tempUserMessages, setTempUserMessages] = useState('');
  const [markerToDisplay, setMarkerToDisplay] = useState();
  const [audioTrack, setAudioTrack] = useState(null);
  const mediaStreamRef = useRef(null);
  const audioTrackRef = useRef(null);
  const audioContextRef = useRef(null);
  const processorRef = useRef(null);
  const [isMuted, setIsMuted] = useState(false);
  const [pingId, setPingId] = useState();
  useEffect(() => {
    audioTrackRef.current = audioTrack;
  }, [audioTrack]);
  let audioQueue = [];
  let isPlaying = false;
  const {
    setLoadingStatus,
    chatMessages,
    setChatMessages,
    isMobile,
    setStartRealTime
  } = useContext(ChatbotDataContext);
  function audioToItemAppendEvent(base64AudioData) {
    return {
      type: 'input_audio_buffer.append',
      audio: base64AudioData
    };
  }
  function commit() {
    const commitObj = {
      type: 'input_audio_buffer.commit'
    };
    ws === null || ws === void 0 ? void 0 : ws.send(JSON.stringify(commitObj));
  }
  function handleStopRecording() {
    setIsMuted(false);
    localStorage.setItem('isAudioInterrupted', 'yes');
    const cancelResponse = {
      type: 'response.cancel'
    };
    ws === null || ws === void 0 ? void 0 : ws.send(JSON.stringify(cancelResponse));
    if (processorRef.current && audioContextRef.current) {
      processorRef.current.disconnect();
      audioContextRef.current.close();
      console.log('Recording stopped'); // TODO REMOVE CONSOLE LOG STATEMENTS
      setIsRecording(false);
      commit();
    }
    if (audioTrackRef.current) {
      audioTrackRef.current.stop();
      setAudioTrack(null);
      audioTrackRef.current = null;
      console.log('Audio track stopped and cleared'); // TODO REMOVE CONSOLE LOG STATEMENTS
    }
  }
  function localEnvWebSocketUrl() {
    if (typeof window === 'undefined') return '';
    switch (window.location.hostname) {
      case 'localhost':
        return 'ws://0.0.0.0:8080';
      case 'local.priceline.com':
        return 'wss://local.priceline.com';
      default:
        return '';
    }
  }
  function convertUrlToWebSocketProtocol(domain) {
    if (process.env.NODE_ENV === 'development') {
      return localEnvWebSocketUrl();
    }
    return domain.replace(/^http:/, 'ws:').replace(/^https:/, 'wss:');
  }
  function playPCM16(base64AudioData, sampleRate = 24000) {
    audioQueue.push({
      base64AudioData,
      sampleRate
    });
    if (!isPlaying) {
      playNextInQueue();
    }
  }
  function playNextInQueue() {
    const isAudioInterupted = localStorage.getItem('isAudioInterrupted') === 'yes';
    if (isAudioInterupted) {
      audioQueue = [];
      isPlaying = false;
      console.log('Audio interrupted, clearing queue'); // TODO REMOVE CONSOLE LOG STATEMENTS
      return;
    }
    if (audioQueue.length === 0) {
      isPlaying = false;
      console.log('Audio queue empty, stopping playback'); // TODO REMOVE CONSOLE LOG STATEMENTS
      return;
    }
    isPlaying = true;
    const {
      base64AudioData,
      sampleRate
    } = audioQueue.shift();
    const audioContext = new window.AudioContext();
    audioContext.onstatechange = () => {
      console.log('AudioContext state changed to:', audioContext.state);
    };
    if (audioContext.state === 'suspended') {
      audioContext.resume();
    }
    const arrayBuffer = base64ToArrayBuffer(base64AudioData);
    const pcm16Array = new Int16Array(arrayBuffer);
    const float32Array = convertPCM16ToFloat32(pcm16Array);
    if (!float32Array || float32Array.some(isNaN)) {
      console.error('Invalid audio data');
      playNextInQueue();
      return;
    }
    const buffer = audioContext.createBuffer(1, float32Array.length, sampleRate);
    buffer.copyToChannel(float32Array, 0);
    const source = audioContext.createBufferSource();
    source.buffer = buffer;
    source.connect(audioContext.destination);
    source.start();
    source.onended = () => {
      console.log('Audio playback ended, playing next in queue'); // TODO REMOVE CONSOLE LOG STATEMENTS
      playNextInQueue();
    };
  }
  useEffect(() => {
    if (window && 'WebSocket' in window && isRecording) {
      const webSocketProtocolDomain = convertUrlToWebSocketProtocol(window.location.origin);
      const websocket = new WebSocket(`${webSocketProtocolDomain}/genai-svc/genai/realtime/chat`);
      websocket.onopen = () => {
        if (realtimeContext) {
          websocket.send(JSON.stringify({
            type: 'client_context',
            data: realtimeContext
          }));
        }
        if (!pingId) {
          const initPingId = setInterval(() => {
            websocket.send('ping');
            console.log('[WebSocket] Ping message sent');
          }, 30000);
          setPingId(initPingId);
        }
        console.log('Connected to the WebSocket server'); // TODO REMOVE CONSOLE LOG STATEMENTS
        setWs(websocket);
      };
      websocket.onclose = () => {
        setRtMessages([{
          role: 'assistant',
          content: 'Connection Lost. Please retry'
        }]);
        console.log('Disconnected from the WebSocket server'); // TODO REMOVE CONSOLE LOG STATEMENTS
        setStartRealTime(false);
        setWs(null);
        clearInterval(pingId);
        setPingId(null);
      };
      websocket.onerror = error => {
        setRtMessages([{
          role: 'assistant',
          content: 'Connection Lost. Please retry'
        }]);
        console.error('Error in WebSocket connection: ', error);
        setStartRealTime(false);
        setWs(null);
      };
      websocket.onmessage = data => {
        if (data.data === 'pong') {
          console.log('[WebSocket] Connection is active');
        } else {
          const message = JSON.parse(data.data);
          if (message.type === 'realtime_marker') {
            setMarkerToDisplay(message.marker);
          }
          if (message.type === 'response.audio.delta') {
            localStorage.setItem('isAudioInterrupted', 'no');
            const newData = message.delta;
            playPCM16(newData);
          }
          if (message.type === 'input_audio_buffer.speech_started') {
            const cancelResponse = {
              type: 'response.cancel'
            };
            websocket.send(JSON.stringify(cancelResponse));
            localStorage.setItem('isAudioInterrupted', 'yes');
          }
          if (message.type === 'conversation.item.input_audio_transcription.completed') {
            const transcript = message.transcript;
            if (transcript !== '') {
              setTempUserMessages(transcript);
            }
          }
          if (message.type === 'response.audio_transcript.done') {
            setLoadingStatus(false);
            const assistantMessage = {
              role: 'assistant',
              content: message.transcript
            };
            setRtMessages([assistantMessage]);
          }
        }
      };
      return () => {
        if (websocket && !isRecording) {
          websocket.close();
          console.log('Closed WebSocket on unmount'); // TODO REMOVE CONSOLE LOG STATEMENTS
        }
      };
    }
  }, [isRecording, realtimeContext]);
  useEffect(() => {
    if (rtMessages && rtMessages.length) {
      const userMessagesObj = {
        role: 'user',
        content: userMessages.join('')
      };
      setChatMessages([...chatMessages, userMessagesObj, ...rtMessages]);
      setUserMessages([]);
    }
  }, [rtMessages]);
  useEffect(() => {
    setUserMessages([...userMessages, tempUserMessages]);
  }, [tempUserMessages]);
  useEffect(() => {
    if (itemCreate) {
      ws === null || ws === void 0 ? void 0 : ws.send(JSON.stringify(itemCreate));
    }
  }, [itemCreate]);
  const handleStartRecording = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    localStorage.setItem('isAudioInterrupted', 'no');
    try {
      const stream = yield navigator.mediaDevices.getUserMedia({
        audio: true
      });
      mediaStreamRef.current = stream;
      const track = stream.getAudioTracks()[0];
      audioTrackRef.current = track;
      setAudioTrack(track);
      const audioContext = new AudioContext({
        sampleRate: 24000
      });
      const mediaStreamSource = audioContext.createMediaStreamSource(stream);
      // This filter is for removal of low Frequency noise (Background noises)
      const highPassFilter = audioContext.createBiquadFilter();
      highPassFilter.type = 'highpass';
      highPassFilter.frequency.value = 200;
      // This filter is for removal of high Frequency noise (Background noises)
      const lowPassFilter = audioContext.createBiquadFilter();
      lowPassFilter.type = 'lowpass';
      lowPassFilter.frequency.value = 4350;
      mediaStreamSource.connect(highPassFilter);
      highPassFilter.connect(lowPassFilter);
      const processor = audioContext.createScriptProcessor(4096, 1, 1);
      lowPassFilter.connect(processor);
      processor.connect(audioContext.destination);
      processor.onaudioprocess = event => {
        var _a;
        if (!((_a = audioTrackRef.current) === null || _a === void 0 ? void 0 : _a.enabled)) {
          console.log('Audio track is muted; skipping processing'); // TODO REMOVE CONSOLE LOG STATEMENTS
          return;
        }
        const float32Array = event.inputBuffer.getChannelData(0);
        const pcm16Array = floatTo16BitPCM(float32Array);
        const base64String = convertPCM16ToBase64(pcm16Array);
        setItemCreate(audioToItemAppendEvent(base64String));
      };
      processorRef.current = processor;
      audioContextRef.current = audioContext;
      setIsRecording(true);
      console.log('Recording started'); // TODO REMOVE CONSOLE LOG STATEMENTS
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  }), []);
  function toggleMute() {
    if (audioTrackRef.current) {
      audioTrackRef.current.enabled = !audioTrackRef.current.enabled;
      setIsMuted(!audioTrackRef.current.enabled);
      console.log(`Microphone is ${audioTrackRef.current.enabled ? 'unmuted' : 'muted'}`); // TODO REMOVE CONSOLE LOG STATEMENTS
    } else {
      console.error('No audio track found to mute/unmute.');
    }
  }
  function handleShouldStart(value) {
    setIsRecording(value);
    if (value) {
      handleStartRecording();
    } else {
      handleStopRecording();
    }
  }
  useEffect(() => {
    handleShouldStart(true);
  }, []);
  useEffect(() => {
    return () => {
      if (ws) {
        console.log('Cleanup started'); // TODO REMOVE CONSOLE LOG STATEMENTS
        if (processorRef.current) {
          console.log('Disconnecting processor'); // TODO REMOVE CONSOLE LOG STATEMENTS
          processorRef.current.disconnect();
        } else {
          console.log('processorRef.current is null'); // TODO REMOVE CONSOLE LOG STATEMENTS
        }
        if (audioContextRef.current) {
          console.log('Closing audio context'); // TODO REMOVE CONSOLE LOG STATEMENTS
          audioContextRef.current.close();
        } else {
          console.log('audioContextRef.current is null'); // TODO REMOVE CONSOLE LOG STATEMENTS
        }
        if (audioTrackRef.current) {
          console.log('Stopping audio track'); // TODO REMOVE CONSOLE LOG STATEMENTS
          audioTrackRef.current.stop();
        } else {
          console.log('audioTrackRef.current is null'); // TODO REMOVE CONSOLE LOG STATEMENTS
        }
        console.log('Closing WebSocket'); // TODO REMOVE CONSOLE LOG STATEMENTS
        ws.close();
      } else {
        console.log('WebSocket is null or undefined'); // TODO REMOVE CONSOLE LOG STATEMENTS
      }
      console.log('Cleanup finished'); // TODO REMOVE CONSOLE LOG STATEMENTS
    };
  }, [ws]);
  return React.createElement(Box, {
    width: 1,
    key: 'chat-dialog-transcript-container',
    style: {
      position: 'absolute',
      top: '0',
      overflowY: 'scroll',
      overflowX: 'hidden',
      zIndex: 1510
    }
  }, React.createElement(Container, null, React.createElement(Flex, {
    flexDirection: 'column',
    height: isMobile ? 'calc(100vh - 85px)' : 'calc(100vh - 91px)'
  }, React.createElement(HeaderWrapper, null, React.createElement(RealTimeHeader, {
    isMobile: isMobile
  })), React.createElement(BodyWrapper, null, ((_a = markerToDisplay === null || markerToDisplay === void 0 ? void 0 : markerToDisplay.markerItem) === null || _a === void 0 ? void 0 : _a.displayComponentName) ? React.createElement(InnerBodyWrapper, null, React.createElement(RenderMarkers, {
    markerToDisplay: markerToDisplay,
    isMobile: isMobile
  })) : React.createElement(ChildWrapper, null, React.createElement(BotWithAnimatedBorder, {
    isMuted: isMuted,
    mediaStreamRef: mediaStreamRef
  })), React.createElement(FooterWrapper, null, React.createElement(ControlWrapper, {
    px: 3
  }, React.createElement(Mic, {
    onClick: toggleMute
  }, isMuted ? React.createElement(Relative, {
    top: '3px'
  }, React.createElement(MicOff, {
    size: '30px',
    color: '#fff'
  })) : React.createElement(Relative, {
    top: '3px'
  }, React.createElement(Microphone, {
    size: '30px',
    color: '#fff'
  }))), React.createElement(Close, {
    onClick: function () {
      if (ws) {
        localStorage.setItem('isAudioInterrupted', 'yes');
        audioQueue = [];
        ws.close();
        setWs(null);
      }
      setStartRealTime(false);
    }
  }, React.createElement(CloseIcon, {
    size: '30px',
    color: '#fff'
  }))))))));
};
export default AudioRecorder;